import React from "react";
import { Clock } from "lucide-react";

const SIDEBAR_IMG =
  "https://static.prod-images.emergentagent.com/jobs/b7334d3c-f0fb-45db-869f-701e05a54f26/images/ac4bc84103b950562a5994e58d0039ac954825852ae998217435733fe8b860e7.png";

const LOCATIONS = ["Aylesbury", "Whitehouse", "Bletchley", "Glebefarm", "Hatfield", "Uxbridge"];

const TimesBlock = ({ label, time }) => (
  <div className="mb-5" data-testid={`run-times-${label.toLowerCase()}`}>
    <div className="flex items-baseline justify-between border-b border-dashed border-dotr-ink pb-1 mb-2">
      <span className="font-heading font-semibold italic text-lg">{label}</span>
      <span className="font-mono text-sm font-bold">{time}</span>
    </div>
    <ul className="font-mono text-sm space-y-1">
      {LOCATIONS.map((loc) => (
        <li key={loc} className="flex items-center justify-between">
          <span className="flex items-center gap-2">
            <span className="inline-block w-1.5 h-1.5 bg-dotr-ink" />
            {loc}
          </span>
          <span className="text-dotr-inkmuted">{time}</span>
        </li>
      ))}
    </ul>
  </div>
);

export const SpokeRunTimes = () => {
  return (
    <aside
      className="brutal-card receipt-bg p-6 md:p-7 sticky top-6 animate-fade-up"
      data-testid="spoke-run-times-card"
    >
      <div className="-mx-6 md:-mx-7 -mt-6 md:-mt-7 mb-5 border-b-2 border-dotr-ink overflow-hidden bg-dotr-muted">
        <img
          src={SIDEBAR_IMG}
          alt="DOTR delivery van illustration"
          className="w-full h-40 object-cover"
          data-testid="sidebar-illustration"
        />
      </div>

      <div className="flex items-center gap-2 mb-5">
        <Clock size={18} strokeWidth={2.5} />
        <h2 className="font-heading font-semibold text-2xl tracking-tight">Spoke Run Times</h2>
      </div>

      <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-dotr-inkmuted mb-4">
        Daily Schedule · UK
      </div>

      <TimesBlock label="Lunch" time="12:45 PM" />
      <TimesBlock label="Dinner" time="4:30 PM" />

      <div className="mt-6 pt-4 border-t border-dashed border-dotr-ink">
        <p className="font-mono text-xs text-dotr-inkmuted leading-relaxed">
          Orders must be logged at least 90 minutes before the scheduled run time. Late entries roll
          to the next slot.
        </p>
      </div>
    </aside>
  );
};
